import { css } from "styled-components";
import { alpha } from "../../../typography";
import { InputVariant } from "./types";

export const inputTypography = (variant: InputVariant) => css`
  ${(variant === "SELECTED" || variant === "FOCUSED") &&
  alpha.primaryActive.body3};
  ${variant === "DEFAULT" && alpha.primaryInactive.body3};
  ${variant === "DISABLED" && alpha.primaryDisabled.body3};
`;
